// api.js
import { toast } from "react-toastify";
import { authAxios } from "../api/config";
import {flaskAuthAxios} from "../Api_Qdrant/Flask_interceptor";

// Note: API_URL constant removed since we're using baseURL from axios instance
export const FAST_API_URL = process.env.REACT_APP_PYTHON_FAST_API_URL;
// ---- Collections ----
export const createCollection = async (name) => {
  try {
    const res = await flaskAuthAxios.post(`/create_collection`, { name });
    return res.data;
  } catch (err) {
    return err.response?.data || { error: err.message };
  }
};

export const deleteCollection = async (name) => {
  try {
    const res = await flaskAuthAxios.delete(`/delete_collection`, {
      params: { name },
    });
    return res.data;
  } catch (err) {
    return err.response?.data || { error: err.message };
  }
};

// ---- Q&A Insert ----
export const insertQA = async (collection, question, answer) => {
  try {
    const res = await flaskAuthAxios.post(
      `/insert_Q&A`,
      { question, answer },
      { params: { collection_name: collection } }
    );
    return res.data;
  } catch (err) {
    return err.response?.data || { error: err.message };
  }
};

export const bulkInsertQA = async (collection, qaList) => {
  try {
    const res = await flaskAuthAxios.post(`/bulk_qa_insert`, qaList, {
      params: { collection },
    });
    return res.data;
  } catch (err) {
    return err.response?.data || { error: err.message };
  }
};

// ---- Get Q&A with pagination ----
export const getQAPaginated = async (
  collection = "CustomAi",
  limit = 25,
  offset = null
) => {
  try {
    const res = await flaskAuthAxios.get(`/getQAsPaginated`, {
      params: { collection, limit, offset },
    });
    return res.data;
  } catch (err) {
    console.error("Error fetching paginated Q&A:", err);
    return err.response?.data || { error: err.message };
  }
};

/* export const deleteQuestionById = async (collection = "CustomAi", questionId = []) => {
  try {
    const res = await flaskAuthAxios.delete(`/deleteQuestionById`, {
      params: { collection: collection, questionId },
    });
    return res.data;
  } catch (err) {
    return err.response?.data || { error: err.message };
  }
}; */

// ---- Search (Public endpoint) ----
export const searchQA = async (collection, query) => {
  try {
    const res = await flaskAuthAxios.post(`/search`, { collection, query });
    console.log("Search result:", res.data);
    return res.data;
  } catch (err) {
    console.error("Search API failed:", err);
    return err.response?.data || { error: err.message };
  }
};

// ---- PDF Upload ----
// Previous upload flow kept for reference:
// export const uploadPdf = async (file, collection_name = "CustomAi") => {
//   const formData = new FormData();
//   formData.append("file", file);
//   formData.append("collection_name", collection_name);
//
//   try {
//     const res = await flaskAuthAxios.post(`/uploadPdfAndGetQa`, formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });
//     return res.data;
//   } catch (err) {
//     console.error("Upload PDF failed:", err);
//     return err.response?.data || { error: err.message };
//   }
// };



// ---- Store QA Pairs ----
export const saveQaPairs = async (collectionName, data) => {
  try {
    const res = await flaskAuthAxios.post(`/bulk_qa_insert`, data, {
      params: { collection: collectionName },
    });
    return res.data;
  } catch (err) {
    toast.error("Save to DB failed");
    return err.response?.data || { error: err.message };
  }
};

// ---- Add single Q&A ----
export const addQAPoint = async (collection, question, answer) => {
  try {
    const res = await flaskAuthAxios.post(
      `/insert_Q&A`,
      { question, answer },
      { params: { collection_name: collection } }
    );
    return res.data;
  } catch (err) {
    toast.error("Failed to add Q&A");
    return err.response?.data || { error: err.message };
  }
};

// ---- Edit Q&A ----
export const editQAPoint = async (
  collection,
  id,
  question,
  answer,
  is_deleted
) => {
  try {
    const res = await flaskAuthAxios.put(
      `/update_QA`,
      { id, question, answer, is_deleted },
      { params: { collection_name: collection } }
    );
    return res.data;
  } catch (err) {
    toast.error("Failed to update Q&A");
    return err.response?.data || { error: err.message };
  }
};

// ---- Delete Q&A ----
export const deleteQAPoint = async (
  collection = "CustomAi",
  question_ids = []
) => {
  try {
    const payload = {
      collection,
      question_ids: question_ids,
    };
    debugger;
    const res = await flaskAuthAxios.delete(`/deleteQuestionById`, {
      data: payload, // 👈 THIS IS THE FIX
    });
    return res.data;
  } catch (err) {
    toast.error("Failed to delete Q&A");
    return err.response?.data || { error: err.message };
  }
};

// ---- Get QA ----
export const GetTotalGeneratedQA = async (collection = "CustomAi") => {
  try {
    const res = await flaskAuthAxios.get(`/total_QA`, {
      params: { collection },
    });
    return res.data;
  } catch (err) {
    return err.response?.data || { error: err.message };
  }
};

// ---- Get Q&A from chat(User-Agent) ----
export const GetQaFromUserAgentChat = async (chatlog, FailedQuestion) => {
  try {
    const res = await flaskAuthAxios.post(`/generateQAFromUserAgentChat`, {
      agent_chat: chatlog,
      failed_question: FailedQuestion,
    });
    return res.data;
  } catch (err) {
    console.error("Error generating Q&A from chat", err);

    // Re-throw the error so the component can handle it properly
    throw err;
  }
};

// ---- Get database Q&A by searching ----
export const GetQaFromDatabaseBySearch = async (
  question,
  collection = "CustomAi"
) => {
  try {
    const payload = {
      collection,
      query: question,
    };

    const res = await flaskAuthAxios.post(`/search-from-qdrant-only`, payload);

    return res.data;
  } catch (err) {
    const errorData = err?.response?.data || { error: err.message };
    console.error("Error getting Q&A from DB:", errorData);
    return errorData;
  }
};

export const getDeletedQAPaginated = async (
  collection = "CustomAi",
  limit = 25,
  offset = null
) => {
  try {
    const res = await flaskAuthAxios.get(`/getAllDeletedQAsPaginated`, {
      params: { collection, limit, offset },
    });
    return res.data;
  } catch (err) {
    console.error("Error fetching paginated Q&A:", err);
    return err.response?.data || { error: err.message };
  }
};

export const softDeleteQa = async (
  collection = "CustomAi",
  question_ids = []
) => {
  try {
    const res = await flaskAuthAxios.post(`/soft-delete-qa-points`, {
      collection,
      question_ids,
    });
    return res.data;
  } catch (err) {
    console.error("Error while soft deleting QA:", err);
    return err.response?.data || { error: err.message };
  }
};

// ---- Search in Soft Deleted Q&A ----
export const searchDeletedQA = async (
  query,
  collection = "CustomAi",
  limit = 10
) => {
  try {
    const payload = {
      query,
      collection,
      limit,
    };

    const res = await flaskAuthAxios.post(
      `/search-deleted-qa-from-qdrant`,
      payload
    );

    return res.data;
  } catch (err) {
    console.error("Error searching deleted Q&A:", err);
    return err.response?.data || { error: err.message };
  }
};

// ---- Restore Soft Deleted Q&A ----
export const restoreDeletedQA = async (
  collection = "CustomAi",
  question_ids = []
) => {
  try {
    const res = await flaskAuthAxios.post(`/restore-deleted-qa-points`, {
      collection,
      question_ids,
    });
    return res.data;
  } catch (err) {
    console.error("Error restoring deleted QA:", err);
    return err.response?.data || { error: err.message };
  }
};

// ---- Voice Interaction (Public endpoint, not currently used but available) ----
export const uploadAudioAndGetVoiceResponse = async (file, collection) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("collection", collection);

  try {
    const res = await flaskAuthAxios.post(
      `/uploadAudioAndGetVoiceResponse`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return res.data;
  } catch (err) {
    console.error("Upload audio failed:", err);
    return err.response?.data || { error: err.message };
  }
};
